import axios from 'axios';
require('es6-promise').polyfill();

const httpClientForConfig = config => ({
	getRemoteDataFor: name => axios.get(config[name]),
	postToEndpoint: (name, data) => {
		const formData = new FormData();
		for (const key of Object.keys(data)) {
			formData.append(key, data[key]);
		}
		return axios({
			url: config[name],
			method: 'post',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
			responseType: 'json',
			data: formData
		});
	}
});
const base64ImageForURL = URL =>
	axios.get(URL, { responseType: 'arraybuffer' }).then(response => {
		let image = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
		return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
	});

const base64ImagesForURLs = URLs => {
	const imagePromises = URLs.map(URL => base64ImageForURL(URL));
	return axios.all(imagePromises).then(base64Sources => {
		return new Promise((resolve, reject) => {
			const images = base64Sources.map(source => {
				const img = new Image();
				img.src = source;
				return img;
			});
			var time = new Date().getTime();
			const checkWidths = () => {
				setTimeout(() => {
					if (images[0].width > 0 && images[1].width > 0) {
						setTimeout(() => {
							resolve(images);
						}, 100);
					} else {
						if ((new Date().getTime() - time) / 1000 > 10) {
							reject(new Error('Images loading timed out.'));
						} else {
							checkWidths();
						}
					}
				}, 10);
			};
			checkWidths();
		});
	});
};

export { httpClientForConfig, base64ImageForURL, base64ImagesForURLs };



// WEBPACK FOOTER //
// ./src/js/utils/http.js